import type { ReactNode } from 'react';
import { usePage } from '@inertiajs/react';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { SiteHeader } from '@/components/layout/SiteHeader';
import { StickyMobileCta } from '@/components/layout/StickyMobileCta';

type PublicLayoutProps = {
  children?: ReactNode;
};

// Shared chrome for every public page: sticky header (+ mobile drawer), page
// content, footer, and the sticky mobile "Request a visit" CTA — hidden on
// Contact (which has its own submit CTA) via the current Inertia component name.
export const PublicLayout = ({ children }: PublicLayoutProps) => {
  const { component } = usePage();
  const hasStickyCta = component !== 'Contact';

  return (
    <>
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter reserveForStickyCta={hasStickyCta} />
      <StickyMobileCta hidden={!hasStickyCta} />
    </>
  );
};
